// @flow
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useEstimateRateCardId } from '@src/custom-hooks/useEstimateRateCardId';

import {
  TIERED_PRICING_CONFIRMATION_MODAL_CONFIG,
  VBD_EDIT_CONFIRMATION_MODAL_CONFIG,
} from '../../../components/common/vbd/constants';
import {
  FieldArrayGridConfigItemContext,
  FieldArrayGridUpdateButton,
} from '../../../formik-utils/FieldArrayGrid';
import {
  useCreateCustomDiscountsMetricsLevelDiscountsMutation,
  useUpdateCustomDiscountsMetricsLevelDiscountsMutation,
} from '../../../service-definitions/estimates';
import { EstimateContext } from '../../../contexts/EstimateContext';
import {
  CONNECT_TIERED_METRIC_NAME,
  DEFAULT_VALUE_FOR_DB_ROW_ID,
  IS_CONNECT_COMMITTED_CAPACITY_LIVE_IN_CE1,
  IS_TABLEFLOW_COMMITTED_CAPACITY_LIVE_IN_CE1,
  METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_MLD_ID_BACKEND_NAME,
  RATE_CARD_BACKEND_NAME,
  ROW_ID,
  TABLEFLOW_TIERED_METRIC_NAME,
} from '../../../constants';
import { getIfRowIsVBD } from '../utils';

const getConfirmationModalDetails = (rowValues) => {
  if (getIfRowIsVBD(rowValues)) {
    return { showConfirmation: true, confirmationConfig: VBD_EDIT_CONFIRMATION_MODAL_CONFIG };
  }

  // TODO: Remove feature flags once Connect and Tableflow committed capacity are fully live
  const isConnectTieredMetric =
    IS_CONNECT_COMMITTED_CAPACITY_LIVE_IN_CE1 &&
    rowValues.metricName === CONNECT_TIERED_METRIC_NAME;

  const isTableflowTieredMetric =
    IS_TABLEFLOW_COMMITTED_CAPACITY_LIVE_IN_CE1 &&
    rowValues.metricName === TABLEFLOW_TIERED_METRIC_NAME;

  if (isConnectTieredMetric || isTableflowTieredMetric) {
    return { showConfirmation: true, confirmationConfig: TIERED_PRICING_CONFIRMATION_MODAL_CONFIG };
  }

  return { showConfirmation: false, confirmationConfig: null };
};

export const DimensionsConfigUpdateButtonContainer = () => {
  const { estimateId } = useParams();
  const estimate = useContext(EstimateContext);

  const [updateCustomDiscountsMetricsLevelDiscounts] =
    useUpdateCustomDiscountsMetricsLevelDiscountsMutation();

  const [createCustomDiscountsMetricsLevelDiscounts] =
    useCreateCustomDiscountsMetricsLevelDiscountsMutation();

  const { columnsConfiguration, rowValues } = useContext(FieldArrayGridConfigItemContext);
  const rateCardVersion = estimate.inputs[RATE_CARD_BACKEND_NAME];
  const rateCardId = useEstimateRateCardId();

  const payload = {
    estimate_id: estimateId,
    estimate_version: estimate?.inputs?.estimate_version,
    ...rowValues,
    metric_name: rowValues.metricName,
    discount: Number(rowValues.discount),
    rate_card_version: rateCardVersion,
    rate_card_id: rateCardId,
    id: rowValues[ROW_ID] === DEFAULT_VALUE_FOR_DB_ROW_ID ? '-1' : rowValues[ROW_ID],
    metricsDiscountId: rowValues[ROW_ID] === DEFAULT_VALUE_FOR_DB_ROW_ID ? '-1' : rowValues[ROW_ID],
    dimensions: {
      ...rowValues,
    },
  };

  const updateFuncParams = {
    estimateId,
    metricsDiscountId:
      rowValues[ROW_ID] === DEFAULT_VALUE_FOR_DB_ROW_ID
        ? null
        : rowValues[METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_MLD_ID_BACKEND_NAME],
    payload,
  };

  const { showConfirmation, confirmationConfig } = getConfirmationModalDetails(rowValues);

  return (
    <FieldArrayGridUpdateButton
      columnsConfig={columnsConfiguration}
      confirmationModalConfig={confirmationConfig}
      errorMessage="There was an error in updating the discount configuration, please contact #cloud-commitment-estimator channel!"
      showConfirmationModal={showConfirmation}
      updateFunc={
        rowValues[ROW_ID] === DEFAULT_VALUE_FOR_DB_ROW_ID
          ? createCustomDiscountsMetricsLevelDiscounts
          : updateCustomDiscountsMetricsLevelDiscounts
      }
      updateFuncParams={updateFuncParams}
    />
  );
};
